import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { Storage } from '@ionic/storage-angular';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DataTablesModule } from 'angular-datatables';
import { NgSelect2Module } from 'ng-select2';

import { LayoutModule } from './layout/layout.module';
import { NgToastModule } from 'ng-angular-popup';
import { SwiperModule } from 'swiper/angular';
import { HttpClientProvider } from './services/http-client';
import { ReactiveFormsModule } from '@angular/forms';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { ComponentsModule } from './components/components.module';
import { MAT_DATE_LOCALE } from '@angular/material/core';

import { CookieService } from 'ngx-cookie-service';
import { ErroInterceptorService, TokenInterceptorService } from './services/interceptor.service';
import { UserService } from './services/user.service';
import { UserModel } from './services/user-model';
import { TradeAgreementsModule } from './pages/trade-agreements/trade-agreements.module';
import { NewTradeAgreementModule } from './pages/new-trade-agreement/new-trade-agreement.module';
import { NewBranchOfficeModule } from './pages/new-branch-office/new-branch-office.module';
import { NewUserModule } from './pages/new-user/new-user.module';
import { RolesModule } from './pages/roles/roles.module';


function appInitializer(userService: UserService) {
  return () => {
    return new Promise((resolve) => {
      userService.getUserByToken().subscribe().add(resolve);
    });
  };
}


@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    LayoutModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    DataTablesModule,
    NgSelect2Module,
    NgToastModule,
    SwiperModule,
    ReactiveFormsModule,
    LazyLoadImageModule,
    ComponentsModule,
    TradeAgreementsModule,
    NewTradeAgreementModule,
    NewBranchOfficeModule,
    NewUserModule,
    RolesModule
    // DpDatePickerModule
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'es'},
    // IonicStorageModule,
    // Axios,
    HttpClientProvider,
    Storage,
    UserModel,
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        fullLibraryLoader: () => import('highlight.js')
      }
    },
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErroInterceptorService, multi: true },
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: appInitializer,
    //   multi: true,
    //   deps: [UserService],
    // },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
